import { fetchApi, postApi } from 'api/fetchApi'
import { paths } from 'api/generated/personal_data'

type Archive = paths['/personal_data/archive/request']
type ArchiveGet = Archive['get']
export type ArchiveGetResponse = ArchiveGet['responses']['200']['schema']
type ArchivePostBody = Archive['post']['parameters']['body']['body']
export type ArchivePostResponse = Archive['post']['responses']['204']

type ArchiveLink = paths['/personal_data/archive']
type ArchiveLinkPost = ArchiveLink['post']
type ArchiveLinkPostBody = ArchiveLink['post']['parameters']['body']['body']

type ArchiveLinkPostResponse = ArchiveLinkPost['responses']['200']['schema']

export const fetchArchiveStatusApi = () =>
  fetchApi<ArchiveGetResponse>('/personal_data/archive/request')

// {"requestedAt":1535980216,"ready":true,"info":{"size":3037554,"expiresAt":1536585030}}
export const requestArchiveApi = (password: string) =>
  postApi<ArchivePostResponse, ArchivePostBody>(
    '/personal_data/archive/request',
    {
      password,
    }
  )

export const fetchArchiveUrlApi = (password: string) =>
  postApi<ArchiveLinkPostResponse, ArchiveLinkPostBody>(
    '/personal_data/archive',
    { password }
  )
